import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
    stampCardSorterAtom,
    historyScopeAtom,
} from '../atoms/stampAtoms';

function useStampCards() {
    const { t } = useTranslation('stamp');
    const sorter = useAtomValue(stampCardSorterAtom);
    const setHistoryScope = useSetAtom(historyScopeAtom);
    const { pop } = useFlow();
    const toast = useToast();
    const { data, status } = useQuery(queries.stamps.cardList(sorter));
    useEffect(() => {
        if (status === 'error') {
            pop();
            toast.error(t('error.loadFailed'));
        }
    }, [status]);
    // 내역을 조회하기 위한 필드 설정
    useEffect(() => {
        if (data && data.cards.length > 0) {
            const { targetScope, shopId, shopGroupId } = data.cards[0];
            switch (targetScope) {
            case 'SHOP_GROUP':
                setHistoryScope({
                    targetScope: 'SHOP_GROUP',
                    shopGroupId,
                });
                break;
            case 'SHOP':
                setHistoryScope({
                    targetScope: 'SHOP',
                    shopId,
                });
                break;
            default:
                setHistoryScope({
                    targetScope: 'PROJECT',
                });
            }
        }
    }, [data]);
    return data?.cards;
}

export default useStampCards;
